export const SPLIT_IO_FEATURES = {}
Object.freeze(SPLIT_IO_FEATURES)
export const SPLIT_NAMES = []
